module.exports = __webpack_public_path__ + "static/media/Star.434996ff.svg";